import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22d68202"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shopping-cart" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Continue shopping ")

import { onMounted, reactive } from 'vue';
  import Tab from './tab.vue';
  import { request } from '@/utils';
  import { ShoppingCartStore, CheckoutStore } from '@/stores';
  import { IShoppingCart, IShoppingCartItem } from '@/types/shopping-cart';

  // 这里传tab.store ShoppingCartStorets过不了
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const tabs = reactive<Array<{ label: string; store: any, checkoutStore: any }>>([]);

  onMounted(async () => {
    // 要分成两个不同的store处理
    const { data: { shopping_cart_items } } = await request.get<IShoppingCart>('/bean/shopping_cart');
    const commonList: IShoppingCartItem[] = [];
    const subscribeList: IShoppingCartItem[] = [];
    shopping_cart_items.forEach(item => (item.purchase_kind === 'once' ? commonList : subscribeList).push(item));
    if (commonList.length) {
      tabs.push({
        label: 'One-time purchase',
        store: ShoppingCartStore.create<ShoppingCartStore>({
          data: commonList,
        }),
        checkoutStore: CheckoutStore.create<CheckoutStore>()
      });
    }
    if (subscribeList) {
      tabs.push({
        label: 'One-time purchase',
        store: ShoppingCartStore.create<ShoppingCartStore>({
          data: subscribeList,
        }),
        checkoutStore: CheckoutStore.create<CheckoutStore>()
      });
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_AppBack = _resolveComponent("AppBack")!
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppBack, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      (_unref(tabs).length)
        ? (_openBlock(), _createBlock(_component_AppTabs, {
            key: 0,
            class: "cart-tab"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, index) => {
                return (_openBlock(), _createBlock(_component_AppTab, {
                  key: index,
                  label: tab.label
                }, {
                  default: _withCtx(() => [
                    _createVNode(Tab, {
                      store: tab.store,
                      "checkout-store": tab.checkoutStore
                    }, null, 8, ["store", "checkout-store"])
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})